import React from 'react';
import { Box, Typography } from '@mui/material';
import LogoIcon from './LogoIcon';

interface LogoComponentProps {
    text: string;
    logoSize?: number;
}

const LogoComponent: React.FC<LogoComponentProps> = ({ text, logoSize = 30 }) => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <LogoIcon size={logoSize} />
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                {text}
            </Typography>
        </Box>
    );
};

export default LogoComponent;
